// const mapAPI="Nbr60aM3zSyhXbSuB6YcGPWENONMxLGT";


 //windows测试
 // const url="http://localhost:1414";
 // const websocketurl="localhost:1414";
//服务器
const url="/ljblog/api";
const websocketurl="lijieblog.top/ljblog/api";
 const request_code_success=200;

export default {
    url,
    request_code_success,
    websocketurl,

  // mapAPI
}